"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMediasoupDevice = createMediasoupDevice;
const mediasoup_client_1 = require("mediasoup-client");
// Since it is difficult mocking module imports e.g. mediasoup-client new Device(),
// this function `createMediasoupDevice` is provided as a wrapper to allow us to
// more easily test new Device() by overriding the return of `createMediasoupDevice`
function createMediasoupDevice() {
    return new mediasoup_client_1.Device();
}
//# sourceMappingURL=mediasoup-device.js.map